<template>
  <div class="d-flex align-center justify-center">
    <v-switch :value="value" @input="$emit('input', $event)" @change="$emit('change', $event)" />
  </div>
</template>

<script>
export default {
  name: 'dr-filter-boolean-field',
  props: ['value']
}
</script>